<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'enterprise_branch_management.screen_name' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_branch_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="onFilterBranches(0, paginate.pageSize)">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-12">
              <mat-form-field class="mat-full-width">
                <input type="text" autocomplete="off" (focusout)="branch.enterprise.keyword= branch.enterprise.keyword.trim()"
                  #focusInput matInput [placeholder]="'enterprise_branch_management.lbl_branch_name' | translate"
                  name="name" [(ngModel)]="branch.enterprise.keyword" maxlength="200">
                <button mat-button *ngIf="branch.enterprise.keyword" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.enterprise.keyword=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'enterprise_branch_management.cbx_branch_status.lbl_branch_status' | translate}}
                </mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                  [(ngModel)]="branch.enterprise.status" (ngModelChange)="onFilterBranches(0, paginate.pageSize)">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_branch_management.cbx_branch_status.cbx_branch_status_select_all' | translate}}
                  </mat-option>
                  <mat-option value="true" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_branch_management.cbx_branch_status.cbx_branch_status_active' | translate}}
                  </mat-option>
                  <mat-option value="false" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_branch_management.cbx_branch_status.cbx_branch_status_inactive' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-12 d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" [disabled]="isTableLoading">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise_branch_management.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
          <span>{{'enterprise_branch_management.list_branch' | translate}} ({{paginate.totalRow}})</span>

<!--          Thêm mới danh sách chi nhánh-->
         <!-- <button class="pull-right" mat-stroked-button color="primary" routerLink="/home-enterprise/add-branch">
           <mat-icon class="mr-0">add_circle</mat-icon>{{'enterprise_branch_management.buttons.add' | translate}}
         </button> -->
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table mat-table [dataSource]="dataSource">
            <!-- STT Column -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_branch_management.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{paginate.no[dataSource.filteredData.indexOf(element)]}}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tên chi nhánh Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%; text-align: center;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_branch_management.table_headers.branch_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 30%;" matTooltip="{{element.name}}"
                class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mã số thuế Column -->
            <ng-container matColumnDef="taxCode">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="width: 14%;">
                {{'enterprise_branch_management.table_headers.tax_code' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-right"
                style="width: 14%;">
                {{element.taxCode}}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 14%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Số giấy tờ Column -->
            <ng-container matColumnDef="certificateNo">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="width: 14%;">
                {{'enterprise_branch_management.table_headers.certificate_no' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-right"
                        style="width: 14%;">
                {{element.certificateNo}}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 14%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Người đại diện Column -->
            <ng-container matColumnDef="representative">
              <mat-header-cell *matHeaderCellDef style="max-width: 18%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_branch_management.table_headers.representative' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 18%;" matTooltip="{{element.representative}}"
                class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.representative}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 18%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef style="max-width: 18%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_branch_management.table_headers.email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 18%;" matTooltip="{{element.email}}"
                class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.email}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 18%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Số điện thoại Column -->
            <ng-container matColumnDef="phone">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center"
                style="max-width: 12%;">
                {{'enterprise_branch_management.table_headers.phone' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="number-cell-center"
                style="max-width: 12%;">
                <span class="fix-width">{{element.phone}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 12%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom" style="max-width: 50px;">
                {{'enterprise_branch_management.table_headers.status' | translate}}
              </mat-header-cell>
              <!-- [matTooltip]="element.status? ('enterprise_branch_management.tooltips.icon_status_active' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)
                : ('enterprise_branch_management.tooltips.icon_status_inactive' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)" -->
              <mat-cell *matCellDef="let element"
                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom" style="max-width: 50px;"
                matTooltipClass="matTooltipBreakLine"
                [matTooltip]="element.status? ('enterprise_branch_management.tooltips.icon_status_active' | translate) : ('enterprise_branch_management.tooltips.icon_status_inactive' | translate)">
                <button mat-icon-button (click)="onClickIconChangeStatus(element.id, element.name,element.status)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon *ngIf="!element.status">lock</mat-icon>
                  <mat-icon *ngIf="element.status">lock_open</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell status-col" style="max-width: 50px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Setting Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 90px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 90px;">
                <button mat-icon-button (click)="onClickBtnView('/home-enterprise/view-detail-branch/', element.id)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.view' | translate}}">
                    visibility</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 90px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot;
                 an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterBranches($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
